@if (loadingIndicatorService.isLoading$ | async) {
  <mat-progress-bar
    mode="indeterminate"
    class="kt__progress-bar"
    >
  </mat-progress-bar>
}
